import { useState, useEffect, useCallback } from "react";

// 防抖函数
const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

// 自定义钩子
const useResponsiveScaling = (minWidth = 800) => {
  const [scale, setScale] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // 使用防抖优化的resize处理函数
  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);

      if (newWidth < minWidth) {
        setScale(newWidth / minWidth);
      } else {
        setScale(1);
      }
    }, 150),
    [minWidth],
  );

  useEffect(() => {
    // 初始计算
    if (windowWidth < minWidth) {
      setScale(windowWidth / minWidth);
    }

    // 添加事件监听
    window.addEventListener("resize", handleResize);

    // 清理函数
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize, minWidth, windowWidth]);

  // 返回缩放样式
  return {
    scale,
    style: {
      transform: `scale(${scale})`,
      transformOrigin: "top left",
      width: `${100 / scale}%`,
      minHeight: `${100 / scale}vh`,
      transition: "transform 0.3s ease",
    },
  };
};

export default useResponsiveScaling;
